import {MyopMessages} from "../../common/MyopMessages";
import {BaseMessageHandler} from "../../common";
import {GetAttributeMessage, GetAttributeReplayMessage} from "../../messages";
import {getFirstElementByRef} from "../../common/messageHandlers/helpers";

export class GetAttributeHandler extends BaseMessageHandler<GetAttributeMessage> {

    messageType = MyopMessages.GetAttributeMessage;

    executor = (event: GetAttributeMessage) => {
        const item = getFirstElementByRef(event.ref, document)
        if (item) {
            this.messageToHost(new GetAttributeReplayMessage(item.getAttribute(event.name)), event);
        }
    }
}
